var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59989 19.8H15.5999C16.9254 19.8 17.9999 18.636 17.9999 17.2V7.54286V6.8C17.9999 5.36406 16.9254 4.2 15.5999 4.2H3.59989C2.27441 4.2 1.19989 5.36406 1.19989 6.8V17.2C1.19989 18.636 2.27441 19.8 3.59989 19.8Z",
    stroke: "#979EBE",
    strokeWidth: 1.92,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02679 9.55555C6.3508 9.55555 6.61346 9.28195 6.61346 8.94444C6.61346 8.60693 6.3508 8.33333 6.02679 8.33333C5.70278 8.33333 5.44012 8.60693 5.44012 8.94444C5.44012 9.28195 5.70278 9.55555 6.02679 9.55555Z",
    fill: "#979EBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3467 9.55558L23.04 5.88892V18.1111L18.3467 14.4445",
    stroke: "#979EBE",
    strokeWidth: 1.92,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.a5a87d4c2b46df3fe607f04e8d3b4fdf.svg";
export { ForwardRef as ReactComponent };